import { render, staticRenderFns } from "./funnel.vue?vue&type=template&id=201b43bc&scoped=true"
import script from "./funnel.vue?vue&type=script&lang=js"
export * from "./funnel.vue?vue&type=script&lang=js"
import style0 from "./funnel.vue?vue&type=style&index=0&id=201b43bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b43bc",
  null
  
)

export default component.exports